import { view } from '@esui/core';
import { DemoPage, Iframe, Section } from '../@demo/utils.js';

function DrawerIframe() {
  return Iframe().style({
    height: '300px',
    width: '80vw',
    'margin-bottom': '36px',
    border: 'none',
  });
}

export const [DrawerDemo] = view('drawer-demo', {
  template() {
    return DemoPage(
      Section(
        'Standard Drawer',
        DrawerIframe().title('Standard Drawer').src('/drawer/standard')
      ),

      Section(
        'Standard Drawer With Header',
        DrawerIframe()
          .title('Standard Drawer With Header')
          .src('/drawer/standard-with-header')
      ),

      Section(
        'Dismissible Drawer',
        DrawerIframe().title('Dismissable Drawer').src('/drawer/dismissable')
      ),

      Section(
        'Modal Drawer',
        DrawerIframe().title('Modal Drawer').src('/drawer/modal')
      )
    );
  },
});
